import React, {useEffect, useState} from 'react';
import analytics from '@react-native-firebase/analytics';
import {
  Container,
  Content,
  PlacaContainer,
  PlacaColumn,
  PlacaInfo,
  PlacaTitle,
  PlacaSubtitle,
  ActiveAlertBox,
  ActiveAlertTitle,
  ActiveDebitSwitch,
  DeleteVehicleButton,
  DeleteVehicleButtonIcon,
  DeleteVehicleButtonText,
  DeleteVehicleContainer,
  FipeArea,
  LabelFipe,
  ItemFipe,
  SearchDebitsContainer,
  SearchDebitsContainerColumn,
  SearchDebitsIcon,
  SearchDebitsText,
  SearchDebitsArrowIcon,
  SearchDebitsButton,
  ContentTop,
} from './styles';
import {Header} from '../../../components/Interface/Headers/Header';
import {useNavigation, useRoute} from '@react-navigation/native';
import {Icon} from '../../../components/Interface/Typographies/Icon';
import {useTheme} from 'styled-components/native';
import {RFValue} from 'react-native-responsive-fontsize';
import {Alert} from 'react-native';

import lupa from '../../../assets/images/icons/lupa.webp';
import {api} from '../../../services/api';
import {Loading} from '../../../components/Interface/Loadings/Loading';
import {LinkButton} from '../../../components/Interface/Forms/Buttons/LinkButton';

interface VehicleProps {
  id: {
    $oid: string;
  };
  renavam: string;
  detran: string;
  placa: string;
  documento: string;
  active: boolean;
  person: {
    id: string;
    name: string;
    email: string;
    cpf: string;
    phone: string;
  };
}

interface Params {
  data: VehicleProps;
}

export function Vehicle() {
  const route = useRoute();
  const navigation = useNavigation();

  const {data} = route.params as Params;

  const [isLoading, setIsLoading] = useState(false);
  const [active, setActive] = useState(data.active);

  const theme = useTheme();

  function handleSearchDebits() {
    analytics().logEvent('clica_busca_debitos_alerta_multas');
    navigation.navigate('LoadingDebits', {
      plate: data.placa,
      renavam: data.renavam,
      uf: data.detran,
      document: data.documento,
      typeDebt: 'MULTA',
      origin: 'vehicle_screen',
    });
  }
  async function excluiVeiculo(id: string) {
    setIsLoading(true);
    try {
      const response = await api.post('/deletaVeiculo', {
        id,
      });

      if (response.data) {
        navigation.goBack();
        analytics().logEvent('exclui_veiculo_alerta_multas');
      }
    } catch {
    } finally {
      setIsLoading(false);
    }
  }

  async function deleteVehicleAlert() {
    Alert.alert('Deseja excluir este veículo?', '', [
      {
        text: 'Excluir',
        onPress: () => excluiVeiculo(data.id.$oid),
        style: 'destructive',
      },
      {
        text: 'Cancelar',
        style: 'cancel',
      },
    ]);
  }

  useEffect(() => {
    analytics().logEvent('tela_veiculo_alerta_multas');
  }, []);

  async function ativaVeiculo(id: string) {
    try {
      const response = await api.post('/ativaVeiculo', {
        id,
      });

      if (response.data) {
        analytics().logEvent('ativa_veiculo_tela_veiculo');
        setActive(true);
      }
    } catch {
    } finally {
      setIsLoading(false);
    }
  }

  async function desativaVeiculo(id: string) {
    try {
      const response = await api.post('/desativaVeiculo', {
        id,
      });

      if (response.data) {
        analytics().logEvent('desativa_veiculo_tela_veiculo');
        setActive(false);
      }
    } catch {
    } finally {
      setIsLoading(false);
    }
  }

  const toggleSwitch = (data: VehicleProps) => {
    if (active) {
      desativaVeiculo(data.id.$oid);
    }

    if (!active) {
      ativaVeiculo(data.id.$oid);
    }
  };

  function handleFipe() {
    analytics().logEvent('consulta_fipe_alerta_multas');
    navigation.navigate('LoadingFipe', {placa: data.placa});
  }

  return (
    <Container>
      {isLoading && <Loading />}
      <Header icon="chevron-left" title="Detalhes do veículo" />

      <Content
        contentContainerStyle={{paddingBottom: RFValue(20)}}
        showsVerticalScrollIndicator={false}>
        <ContentTop>
          <PlacaContainer>
            <PlacaColumn>
              <Icon name="car" />
              <PlacaInfo>
                <PlacaTitle>{data.placa}</PlacaTitle>
                <PlacaSubtitle>{data.renavam}</PlacaSubtitle>
              </PlacaInfo>
            </PlacaColumn>
            <FipeArea>
              <LabelFipe>Dados FIPE:</LabelFipe>
              <ItemFipe>
                <LinkButton
                  action={handleFipe}
                  enabled
                  text="Consultar agora"
                />
              </ItemFipe>
            </FipeArea>
          </PlacaContainer>
          <ActiveAlertBox>
            <ActiveAlertTitle>Ativar alerta de multas</ActiveAlertTitle>
            <ActiveDebitSwitch
              trackColor={{
                false: theme.colors.border,
                true: theme.colors.primary,
              }}
              ios_backgroundColor={theme.colors.border}
              onValueChange={() => toggleSwitch(data)}
              value={active}
            />
          </ActiveAlertBox>
        </ContentTop>
        <SearchDebitsContainer>
          <SearchDebitsButton onPress={handleSearchDebits} activeOpacity={0.7}>
            <SearchDebitsContainerColumn>
              <SearchDebitsIcon source={lupa} />
              <SearchDebitsText>
                Consultar os débitos desse veículo
              </SearchDebitsText>
            </SearchDebitsContainerColumn>
            <SearchDebitsArrowIcon name="chevron-right" />
          </SearchDebitsButton>
        </SearchDebitsContainer>

        <DeleteVehicleContainer>
          <DeleteVehicleButton onPress={deleteVehicleAlert} activeOpacity={0.7}>
            <DeleteVehicleButtonIcon name="trash" />
            <DeleteVehicleButtonText>Remover veículo</DeleteVehicleButtonText>
          </DeleteVehicleButton>
        </DeleteVehicleContainer>
      </Content>
    </Container>
  );
}
